module.exports = {"start":"開始","restart":"重新開始","testing":"測試 #{test}","download":"下載","upload":"上載","latency":"時延","jitter":"抖動","poweredBy":"提供者","mbps":"兆比特/秒","kbps":"千比特/秒","ms":"毫秒","s":"秒","internetPerformanceTest":"互聯網性能測試","yourIp":"你的互聯網地址","testServerLocation":"測試服務器位置","referenceNumber":"參考編號","startTest":"開始測試","initialising":"初始化 #{test}","initiateFail":"發生了問題，請再試"}


//////////////////
// WEBPACK FOOTER
// ./src/js/i18n/zh-HK.json
// module id = 206
// module chunks = 0